var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBusinessModels)?_c('span',{staticClass:"stitek stitek--ad",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('show-business-models', _vm.businessModels)}}},[_vm._v("\n  AD"+_vm._s(this.businessModels && this.businessModels.length > 0 ? '!' : '')+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b6f7be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ChannelAdvertisingProviderChannelGroupLabel.vue
// module id = QUbX
// module chunks = 0